var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.8211 9.20698L6.99302 13.0401V0.471924H5.21168V13.0401L1.38357 9.20698L0.136475 10.4554L6.10238 16.427L12.0683 10.4554L10.8211 9.20698Z","fill":"#272726"}));
}

DownArrow.defaultProps = {"width":"13","height":"17","viewBox":"0 0 13 17","fill":"none"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
